<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-08 11:56:01
 -->
<template>
  <ul class="part7">
    <div class="title">停留时间 Length of stay</div>
    <li>
      <el-input
        placeholder="yyyy.MM.dd"
        v-model="part7.arrivalCh"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">到达时间：</template>
      </el-input>
      <el-input
        placeholder="yyyy.MM.dd"
        v-model="part7.departureCh"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">离开时间：</template>
      </el-input>
      <el-input
        placeholder="请输入夜次数"
        v-model="part7.nightsCh"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">住宿过夜数：</template>
      </el-input>
    </li>
    <li>
      <el-input
        placeholder="yyyy.MM.dd"
        v-model="part7.arrivalEn"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">Day of arrival：</template>
      </el-input>
      <el-input
        placeholder="yyyy.MM.dd"
        v-model="part7.departureEn"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">Day of departure：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="part7.nightsEn"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">Total number of nights：</template>
      </el-input>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    Lengthstayh: {
      type: Object,
      default() {
        return {
          type: 0,
          data: null,
        };
      },
    },
    stateCode: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      part7: {
        arrivalCh: "", //到达时间
        arrivalEn: "",
        departureCh: "", //离开时间
        departureEn: "",
        nightsCh: "", //住宿过夜数
        nightsEn: "",
      },
    };
  },

  created() {},
  mounted() {
    this.getdetails();
  },
  methods: {
    getdetails() {
      this.part7.arrivalCh = this.Lengthstayh.arrivalCh;
      this.part7.arrivalEn = this.Lengthstayh.arrivalEn;
      this.part7.departureCh = this.Lengthstayh.departureCh;
      this.part7.departureEn = this.Lengthstayh.departureEn;
      this.part7.nightsCh = this.Lengthstayh.nightsCh;
      this.part7.nightsEn = this.Lengthstayh.nightsEn;
    },
  },
};
</script>

<style scoped="" lang="scss">
.part7 {
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3c4353;
    margin: 48px 100px;
  }

  li {
    display: flex;
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 20px;
    div {
      width: 34.5%;
    }
    .el-input {
      /deep/ .el-input-group__prepend {
        border-right: 0;
        color: rgba(36, 85, 139, 1);
        background: white;
        padding-right: 0px;
      }
      /deep/.el-input__inner {
        border-left: 0;
        padding: 0 15px 0 0;
        &:focus {
          border-color: #dcdfe6;
          outline: 0;
        }
      }
    }

    .radiobox {
      width: 30%;
      border: 1px solid gainsboro;
      .el-radio {
        margin-left: 30px;
        margin-top: 14px;
      }
    }
    p {
      color: rgba(36, 85, 139, 1);
      line-height: 32px;
    }
  }

  li:nth-of-type(3) {
    margin-top: 30px;
  }

  li:nth-of-type(5) {
    margin-top: 30px;
  }
}
</style>
